import {
  tabClasses,
  tabsClasses,
} from '@mui/material';
import {
  Tab as MuiTab,
  Tabs as MuiTabs,
} from '@mui/material';
import Box from '@mui/material/Box';
import {
  alpha,
  styled,
} from '@mui/material/styles';
import type { TabProps } from '@mui/material/Tab';
import { type TabsProps } from '@mui/material/Tabs';
import type {
  ReactNode,
  SyntheticEvent,
} from 'react';

interface StyledTabsProps<ValueType = any> extends TabsProps {
  children?: ReactNode;
  value: ValueType;
  onChange: (event: SyntheticEvent, newValue: ValueType) => void;
}

export const TabIndicator = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.primary.main,
  borderRadius: '6px 6px 0px 0px',
}));

export const Tabs = styled((props: StyledTabsProps) => (
  <MuiTabs {...props} slotProps={{ indicator: { children: <TabIndicator /> } }} />
))({
  minHeight: 41,
  [`& .${tabsClasses.indicator}`]: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    height: 4,
  },
});

interface StyledTabProps extends TabProps {
  label: ReactNode;
}

export const Tab = styled((props: StyledTabProps) => (
  <MuiTab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '17px',
  color: alpha(theme.palette.common.black, 0.55),
  fontFamily: theme.typography.body1.fontFamily,
  padding: '10px 0',
  minHeight: 37,
  marginRight: 36,
  [`&.${tabClasses.root}.${tabClasses.selected}`]: {
    color: theme.palette.primary.main,
  },
}));
